module.exports = __webpack_public_path__ + "static/media/github.48b8862d.png";